import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import asReduxFormField from '@common/components/FormElements/asReduxFormField';

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Fields = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  flex-direction: column;
  gap: 0.5rem;
`;

export const NameInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  ${media.md`
    flex-direction: row;
    gap: 0;
  `}
`;

export const SalutationInput = styled.div`
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 200px;

  ${media.md`
    max-width: initial;
  `}
`;

export const NameInput = styled.div`
  display: flex;
  flex-basis: 0;

  ${media.md`
    flex-grow: 3;
    margin-left: 12px;
  `}
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  flex-direction: column;
`;

export const MessageInputs = styled.div`
  padding: 10px 0;
  border: 1px solid ${({ theme }) => theme.defaultColors.grey};
  border-radius: 3px;
  transition: 0.3s all;
  margin-bottom: 6px;

  &:focus-within {
    border-color: ${({ theme }) => theme.customColors.primary};
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 0 10px;
  line-height: 22px;
  background-color: ${({ theme }) => theme.defaultColors.white};
  transition: 0.3s all;
  font-size: 16px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  border-radius: 3px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
`;

export const ReduxFormInput = asReduxFormField(StyledInput);

export const Image = styled.div`
  display: none;
  flex-grow: 1;
  flex-basis: 0;
  img {
    width: 100%;
    padding: 0 35px;
  }

  ${media.md`
    display: flex;
  `}
`;
